import { ISessionMessageResponse, ISessionMessageState, IStreamData } from '../../../interfaces';
import { SessionResponse, SessionState } from 'sfx-web-contract';

const sessionStateMap = new Map<SessionState, ISessionMessageState>([
    [ SessionState.SESSIONSTATE_END, 'end' ],
    [ SessionState.SESSIONSTATE_UNKNOWN, 'unknown' ],
]);

export function decodeSessionResponse(
    response: IStreamData<Uint8Array>,
): ISessionMessageResponse {
    const {
        State,
    } = SessionResponse.decode(response.payload);

    return {
        state: sessionStateMap.get(State),
    };
}
